import React, { useState } from 'react';
import NodeMenuButton from './NodeMenuButton';
import { Menu } from '@mui/material';
var extendChildrenWithProps = function (children, closeMenu) {
    return React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                closeMenu: closeMenu,
            });
        }
        else if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                closeMenu: closeMenu,
            });
        }
        else {
            return child;
        }
    });
};
var NodeMenu = function (_a) {
    var buttonColor = _a.buttonColor, nodeWidth = _a.nodeWidth, menuItems = _a.menuItems;
    var _b = useState(null), menuAnchor = _b[0], setMenuAnchor = _b[1];
    if (!menuItems) {
        return null;
    }
    var handleCloseMenu = function () {
        setMenuAnchor(null);
    };
    var handleOpenMenu = function (e) {
        setMenuAnchor(e.currentTarget);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NodeMenuButton, { buttonColor: buttonColor, nodeWidth: nodeWidth, onClick: handleOpenMenu }),
        React.createElement(Menu, { open: !!menuAnchor, anchorEl: menuAnchor, container: document.getElementById('appContainer'), anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, onClose: handleCloseMenu }, extendChildrenWithProps(menuItems, handleCloseMenu))));
};
export default NodeMenu;
//# sourceMappingURL=NodeMenu.js.map